import { AccountNotAChapel } from "../utils/PortalPermission";
import { DOMAIN_NAMES } from "./Domain";

export const APP_PERMISSIONS = {
    login:              'login',
    drive_access:       'drive_access',
    drive_upload:       'drive_upload',
    // Federated
    // ffda_1099_rw:       'ffda_1099_rw',
    ffda_dashboard_rw:  'ffda_dashboard_rw',
    ffda_supplies_rw:   'ffda_supplies_rw',
    ffda_reports:       'ffda_reports',
}

export const PERMISSION_MAP = {
    [DOMAIN_NAMES.FIDUCIAL]: [{
        label: 'Login',
        key: APP_PERMISSIONS.login,
        choice: [{
            label: 'No access',
            value: false
        },{
            label: 'Yes',
            value: true
        }]
    },{
        label: 'Documents - Access',
        key: APP_PERMISSIONS.drive_access,
        choice: [{
            label: 'No access',
            value: false
        },{
            label: 'Yes',
            value: true
        }]
    },{
        label: 'Documents - Upload',
        key: APP_PERMISSIONS.drive_upload,
        choice: [{
            label: 'No access',
            value: false
        },{
            label: 'Yes',
            value: true
        }]
    }],
    [DOMAIN_NAMES.FIDUCIAL_FEDERATED]: [{
        label: 'Login',
        key: APP_PERMISSIONS.login,
        choice: [{
            label: 'No access',
            value: false
        },{
            label: 'Yes',
            value: true
        }]
    },{
        label: 'Documents - Access',
        key: APP_PERMISSIONS.drive_access,
        choice: [{
            label: 'No access',
            value: false
        },{
            label: 'Yes',
            value: true
        }]
    },{
        label: 'Documents - Upload',
        key: APP_PERMISSIONS.drive_upload,
        choice: [{
            label: 'No access',
            value: false
        },{
            label: 'Yes',
            value: true
        }]
    },{
        label: 'Dashboard',
        key: APP_PERMISSIONS.ffda_dashboard_rw,
        isUsable: AccountNotAChapel,
        choice: [{
            label: 'No access',
            value: false
        },{
            label: 'Yes',
            value: true
        }]
    },{
        label: 'Reporting',
        key: APP_PERMISSIONS.ffda_reports,
        choice: [{
            label: 'No access',
            value: false
        },{
            label: 'Yes',
            value: true
        }],
        goToTabOption: {
            tabName: 'tab-item-reports',
            label: 'Configure access',
        }
    },
    // {
    //     label: '1099s',
    //     key: APP_PERMISSIONS.ffda_1099_rw,
    //     choice: [{
    //         label: 'No access',
    //         value: false
    //     },{
    //         label: 'Yes',
    //         value: true
    //     }]
    // }
    ,{
        label: 'Supplies',
        key: APP_PERMISSIONS.ffda_supplies_rw,
        choice: [{
            label: 'No access',
            value: false
        },{
            label: 'Yes',
            value: true
        }]
    }]
};

PERMISSION_MAP[DOMAIN_NAMES.FIDUCIAL_JADE] = PERMISSION_MAP[DOMAIN_NAMES.FIDUCIAL];
